import { render, staticRenderFns } from "./DashboardView.vue?vue&type=template&id=3e91a9b4&scoped=true"
import script from "./DashboardView.ts?vue&type=script&lang=ts&external"
export * from "./DashboardView.ts?vue&type=script&lang=ts&external"
import style0 from "./DashboardView.scss?vue&type=style&index=0&id=3e91a9b4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e91a9b4",
  null
  
)

export default component.exports